import React from 'react';
import '@atlaskit/css-reset';
import styled from '@emotion/styled';
import Select from 'react-select';
import "./css/checkbox.css";
import boardImg from "./assets/columns.png";
import GPTModal from './GPTModal';
import { getBoardIdFromURL} from "./../util/common";

const Container = styled.nav`
  width: 100%;
  background-color: #fbfafa;
  margin-left: 10px;
  margin-right: 10px;
  padding: 10px 16px;
  position: fixed;
  z-index: 888;
  box-shadow: 0 2px 3px rgba(96, 96, 96, .1);
  box-sizing: border-box;

  display: grid;
  grid-template-columns: minmax(160px, 260px) 1fr auto;
  align-items: center;
  column-gap: 16px;
  row-gap: 8px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const TitleZone = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`;

const FiltersZone = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

const ActionsZone = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-self: end;
`;

const CheckBoxContainer = styled.div`
  display: inline-block;
  white-space: nowrap;
`;

const TagFilterContainer = styled.div`
  min-width: 220px;
  max-width: 420px;
  flex: 1;
  font-family: 'Segoe UI Regular';
`;

const BoardTitle = styled.h1`
  font-size: 18px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
  min-width: 0;
  flex: 1;
 `;

const BoardIcon = styled.img`
  width: 22px;
  margin-right: 8px;
  flex-shrink: 0;
`;

const ResetButton = styled.button`
  cursor: pointer;
  font-size: 14px;
  opacity: 0.7;
  transition: opacity 0.2s ease;
  background: none;
  border: none;
  padding: 4px 8px;
  font-family: inherit;
  color: inherit;
  white-space: nowrap;

  &:hover,
  &:focus {
   opacity: 1;
  }

  &:focus {
    outline: 2px solid #0052CC;
    outline-offset: 2px;
    border-radius: 3px;
  }
`;


const colourStyles = {
  multiValue: (styles, { data }) => {
     return {
      ...styles,
      backgroundColor: data.color
    };
  },
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: 'white',
  })
};

const CheckBox = (props) => {
  return (
    <label className="pure-material-checkbox">
      <input type="checkbox" checked={props.isChecked} onChange={props.onChange} />
      <span>{props.label}</span>
    </label>
  );
}

export default class Filter extends React.Component {
  constructor(props) {
    super(props);
 
  }

  handleChange = (selectedTags) => {
    this.props.onFilterChange("selectedTags", selectedTags);
  };

  onResetFilterClick = () => {
    this.props.resetFilters();   
  }

  

  render() {
    const { allTags, onFilterChange, selectedTags, showOnlyUserCards, sortByVotes, boardTitle, columnNames } = this.props;
    let tagFilterOptions = [];
    if (allTags && allTags.size > 0) {
      tagFilterOptions = Array.from(allTags).map(
        ([tagName, color]) => ({value: tagName, label: tagName, color})
      );
    }
    const columnsDescription = columnNames && columnNames.length > 0
      ? `${columnNames.length} ${columnNames.length === 1 ? 'column' : 'columns'}: ${columnNames.join(', ')}`
      : 'no columns yet';
    const orientationLabel = boardTitle
      ? `${boardTitle} — brainstorming board with ${columnsDescription}`
      : `Brainstorming board with ${columnsDescription}`;

    return <Container aria-label="Board filters and actions">
      <TitleZone>
        <BoardIcon src={boardImg} alt="" aria-hidden="true" />
        <BoardTitle aria-label={orientationLabel} title={boardTitle}>
          {boardTitle}
        </BoardTitle>
      </TitleZone>

      <FiltersZone>
        {tagFilterOptions?.length > 0 && <TagFilterContainer>
          <Select
            value={selectedTags}
            styles={colourStyles}
            onChange={this.handleChange}
            options={tagFilterOptions}
            isMulti={true}
            placeholder="Filter cards by tags"
            noOptionsMessage={()=> "Hmm.. we couldn't find any tags on this board"}
            aria-label="Filter cards by tags"
          />
        </TagFilterContainer>
        }
        <CheckBoxContainer>
          <CheckBox label="Show only my cards" isChecked={showOnlyUserCards} onChange={(e) => onFilterChange("showOnlyUserCards", !showOnlyUserCards)} />
        </CheckBoxContainer>
        <CheckBoxContainer>
          <CheckBox label="Order cards by votes" isChecked={sortByVotes} onChange={(e) => onFilterChange("sortByVotes", !sortByVotes)} />
        </CheckBoxContainer>
      </FiltersZone>

      <ActionsZone>
        <ResetButton type="button" onClick={this.onResetFilterClick}>
          Reset filters
        </ResetButton>
        {getBoardIdFromURL() !== 'aLshwIVY6KVIJHBkOah4' && this.props?.numberOfCards != null && this.props?.numberOfCards > 5 && <GPTModal /> }
      </ActionsZone>
    </Container>
  }
}
